module.exports = __webpack_public_path__ + "static/assets/fb112c7cc640f598ab7c61ebbf21b852.svg";